export default "__VITE_PUBLIC_ASSET__ee66f265__"